import 'styles/variables.css';
import 'styles/modal-transaction.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'config/yupLocale';
import 'config/moment';
import 'config/react-intl';
import 'config/chat';
import 'styles/react_dates_overrides.css';
import 'v2/services/eduzzAccount';
import './hotjar';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { App } from './App';

ReactDOM.render(<App />, document.getElementById('app') as HTMLElement);
